import { memo, useCallback, useEffect, useRef, useState } from "react";
import { AiFillLock, AiFillPrinter, AiFillUnlock } from "react-icons/ai";
import { HiPencil } from "react-icons/hi";
import { IoClose, IoRefreshCircle } from "react-icons/io5";
import {
  MdDelete,
  MdExpandLess,
  MdExpandMore,
  MdOutlineArrowBackIosNew,
  MdOutlineArrowForwardIos,
  MdOutlineCallMerge,
} from "react-icons/md";
import { RiRefreshLine } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { useEventListener } from "usehooks-ts";
import AddIcon from "../../../../../Assets/ReactIcons/AddIcon";
import CopyIcon from "../../../../../Assets/ReactIcons/CopyIcon";
import ViewIcon from "../../../../../Assets/ReactIcons/ViewIcon";
import process_icon from "../../../../../Assets/icons/process_icon.png";
import { replaceUnderscore } from "../../../../../CommonFunction/common";
import InvoiceFormat from "../../../../Pages/InvoiceFormat/InvoiceFormat";
import Image from "../../../Image/Image";
import { useModalContext } from "../../../Reactportal/ModalContext";
import { WarningToast } from "../../../ToastComponent/RectHotToast";
import "./IconsDiv.scss";
import { toggleExpandAllState } from "./iconsAtomStates";
import { IoIosNotifications } from "react-icons/io";
import BulkNotifications from "../../../../Pages/BulkNotifications/BulkNotifications";

function IconsDiv({ title, func, closeFun, TableKey, MoreActions, MoreIcons }) {
  const { getTopModal } = useModalContext();
  const location = useLocation();
  const [type, setType] = useState("");
  const [Notification, setNotification] = useState(false);
  const Refresh_icon_ref = useRef(null);
  const Refresh_Count_ref = useRef(null);
  const Add_icon_ref = useRef(null);
  const dispatch = useDispatch();
  const [toggle, settoggle] = useState(false);
  let Refetch = useSelector((store) => store?.FormFieldData.refresh);
  const Tab = useSelector((store) => store.SelectedTabData.tab);
  const fielddataRedux = useSelector((store) => store.UniqueTableReducer);

  const [isOpenExpand, setIsOpenExpand] = useRecoilState(toggleExpandAllState);

  const RowSelect = fielddataRedux?.[TableKey]?.Selected_Row ? true : false;

  const Is_lockCheck = fielddataRedux[TableKey]?.Selected_Rows;
  // console.log(Is_lockCheck, "Is_lockCheck");

  let idsToLock = [];
  let idsToUnLock = [];

  if (Is_lockCheck?.length > 0) {
    Is_lockCheck.forEach((doc) => {
      if (doc.Is_Lock) {
        idsToUnLock.push(doc._id);
      } else if (doc.Is_Lock === false) {
        idsToLock.push(doc._id);
      }
    });
  }

  const history = useNavigate();

  // Function to set the action for opening a specific type of portal, such as add, view, edit, or delete.
  // and also to perform Refresh operation
  let ParentPortalCloseFunction = useCallback(() => {
    sessionStorage.setItem("UserSelectedBranch", JSON.stringify({}));
    dispatch({ type: "CLEAR_COMPONENT_PROP" });
    settoggle(false);
  }, []);
  const baseProps = { show: true, ParentPortalCloseFunction };

  function getComponentProps(type, tab) {
    switch (type) {
      case "Add":
        return { ...baseProps, TypeOfPortal: "Add", submitType: "Save" };
      case "Copy":
        return { ...baseProps, TypeOfPortal: "Copy" };
      case "Edit":
        return { ...baseProps, TypeOfPortal: "Edit" };
      case "View":
        return { ...baseProps, TypeOfPortal: "View", submitType: "View" };
      case "Delete":
        return { ...baseProps, TypeOfPortal: "Delete", SubmitType: "Delete" };
      case "Merge":
        return { ...baseProps, TypeOfPortal: "Merge" };
      case "Lock":
        return { ...baseProps, TypeOfPortal: "Lock", SubmitType: "Lock" };
      case "Unlock":
        return { ...baseProps, TypeOfPortal: "Unlock", SubmitType: "Unlock" };
      case "process":
        return getProcessProps(tab);
      case "update":
        if (tab === "Pending") {
          return { ...baseProps, TypeOfPortal: "Update Pending POD", SubmitType: "Save" };
        }
        break;
      default:
        return baseProps;
    }
  }

  function getProcessProps(tab) {
    switch (tab) {
      case "Collected":
        return { ...baseProps, TypeOfPortal: "Collected POD", SubmitType: "Save" };
      case "Intransit":
        return { ...baseProps, TypeOfPortal: "Intransit POD Process", SubmitType: "Save" };
      case "Received":
        return { ...baseProps, TypeOfPortal: "Received POD Process", SubmitType: "Save" };
      case "Pending":
      case "Processed":
        return { ...baseProps, TypeOfPortal: "Payment Process", SubmitType: "Save" };
      default:
        return baseProps;
    }
  }

  let path = window.location.pathname;

  let rights = {
    ...useSelector(
      (state) => state.userRightsReducer.userRightsData[path] || state.userRightsReducer.userRightsData["/Ledger"]
    ),
    ...MoreActions,
  };

  const P_Select_row = () => {
    if (fielddataRedux[TableKey]?.Selected_Rows?.length > 1) {
      WarningToast("Please select Only Single Entry");
    } else if (fielddataRedux[TableKey]?.Selected_Rows?.length === 0) {
      WarningToast(`Please select the Entry `);
    }
  };

  // const checkMinimumRowSelection = () => {
  //   if (TableTitleTableTitle[TableTitle]?.Selected_Rows?.length === 0) {
  //     WarningToast(`Please select the Entry `);
  //     return false;
  //   } else {
  //     return true;
  //   }
  // };

  const IconAction = (action) => {
    if (action === "Print") {
      settoggle(true);
      setType(action);
      return;
    }

    if (idsToUnLock.length > 0) {
      if (["Edit", "Delete"].includes(action)) {
        action = "View";
        WarningToast("Entry is locked.");
      } else if (action === "Lock") {
        if (Is_lockCheck.length === idsToUnLock.length) {
          WarningToast(
            idsToUnLock.length === 1 ? "Entry is already locked." : "All selected entries are already locked."
          );
          return;
        }
        WarningToast("Some entries are already locked.");
      }
    }

    if (idsToLock.length > 0 && action === "Unlock") {
      console.log(Is_lockCheck.length === idsToLock.length, Is_lockCheck, idsToLock);

      if (Is_lockCheck.length === idsToLock.length) {
        WarningToast(
          idsToLock.length === 1 ? "Entry is already unlocked." : "All selected entries are already unlocked."
        );
        return;
      }
      WarningToast("Some entries are already unlocked.");
    }

    if (action === "Refresh") {
      const icon = Refresh_icon_ref.current;

      if (icon) {
        icon.classList.add("rotatingIcon");
        setTimeout(() => {
          icon.classList.remove("rotatingIcon");
        }, 1000); // Adjust time as needed
      }

      dispatch({ type: "Refetch", payload: !Refetch });
      return;
    } else if (action === "Count") {
      const CountIcon = Refresh_Count_ref.current;
      if (CountIcon) {
        CountIcon.classList.add("rotatingIcon");
        setTimeout(() => {
          CountIcon.classList.remove("rotatingIcon");
        }, 5000); // Adjust time as needed
      }
      return;
    }

    let rowData = fielddataRedux?.[TableKey]?.Selected_Row;
    console.log(rowData, TableKey, "TableKey");
    if (rowData && action === "Edit" && rowData?.Is_Lock) {
      console.log(rowData);
      setType("View");
    } else {
      setType(action);
    }
    const validActions = ["Add", "View", "Edit", "Delete", "Copy", "Merge", "Lock", "Unlock"];

    if (validActions.includes(action)) {
      dispatch({
        type: "SET_COMPONENT_PROP",
        payload: { Table_Key: getTopModal(), props: getComponentProps(action, Tab) },
      });
    }

    settoggle(!toggle);
  };

  //function to enable the functionality of shortcut keys by comparing its key code
  const handleKeyDown = (event) => {
    if (event.ctrlKey && event.key === "n") {
      event?.preventDefault();
      event.stopPropagation();
      event.preventDefault();
      IconAction("Add");
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", function (event) {
      // event.preventDefault();
      // alert("Prevent");
      if (event.ctrlKey && event.key === "n") {
        // event.preventDefault();
        // alert("Ctrl+N is disabled");
      }
    });
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const renderPrintComponent = () => {
    if (type === "Print" && toggle) {
      return (
        <InvoiceFormat
          show={toggle}
          title={title}
          TableKey={TableKey}
          TypeOfPortal={type}
          ParentPortalCloseFunction={ParentPortalCloseFunction}
        />
      );
    }
  };

  // Function to handle keyboard events
  const handleKeyDownForOpen = (event) => {
    if (event.key === "F2" && !toggle) {
      Add_icon_ref.current?.click();
    }
  };

  // Use the useEventListener hook from usehooks-ts to listen for keydown events
  useEventListener("keydown", handleKeyDownForOpen);

  return (
    <div className="left_icons_div">
      <>
        <p className="page_title">{replaceUnderscore(title)}</p>
        {title && <div className="hr1"></div>}
      </>
      <div className="icons_div">
        {["/Profit&Loss", "/BalanceSheet", "/TradingReport"].includes(location.pathname) && (
          <div onClick={() => setIsOpenExpand((prev) => !prev)} style={{ width: "60px" }}>
            <div>
              {isOpenExpand ? (
                <MdExpandLess size={20} className="icon_styling" />
              ) : (
                <MdExpandMore size={20} className="icon_styling " />
              )}
            </div>
            <p className="IconName"> {isOpenExpand ? ` Close  All` : "Expand All"} </p>
          </div>
        )}

        {rights && rights.Is_Back && (
          <div onClick={() => history(-1)}>
            <MdOutlineArrowBackIosNew className="icon_styling" />
            <p className="IconName">BACK</p>
          </div>
        )}

        {rights && rights.Is_Forword && (
          <div onClick={() => history(+1)}>
            <MdOutlineArrowForwardIos className="icon_styling" />
            <p className="IconName">FORWARD</p>
          </div>
        )}
        {rights && rights.Is_Add && (
          <div onClick={() => IconAction("Add")} tabindex="0" role="button" ref={Add_icon_ref}>
            <AddIcon //className="add_icon_style icon_styling"
              className={"add_icon_style icon_styling"}
            />
            <p className={location.pathname === "/POD" ? "IconName account_delete_icon_style" : "IconName"}>ADD</p>
          </div>
        )}

        {rights && rights.Is_View && (
          <div
            onClick={() => {
              if (RowSelect) IconAction("View");
              else P_Select_row();
            }}
          >
            <ViewIcon className="icon_styling" />
            <p className="IconName">VIEW</p>
          </div>
        )}

        {rights && rights.Is_Edit && (
          <div
            onClick={() => {
              if (RowSelect) IconAction("Edit");
              else P_Select_row();
            }}
            id="edit_icon_button"
          >
            <HiPencil className={"icon_styling"} />
            <p className={"IconName"}>EDIT</p>
          </div>
        )}
        {rights && rights.Is_Copy && rights.Is_Add && (
          <div
            onClick={() => {
              if (RowSelect) IconAction("Copy");
              else P_Select_row();
            }}
          >
            <CopyIcon //className="add_icon_style icon_styling"
              className={"icon_styling"}
            />

            <p className={"IconName"}>COPY</p>
          </div>
        )}

        {rights && rights.Is_Delete && rights.Is_Merge ? (
          <div
            onClick={() => {
              if (RowSelect) IconAction("Merge");
              else P_Select_row();
            }}
          >
            <MdOutlineCallMerge className="icon_styling" />
            <p className="IconName">MERGE</p>
          </div>
        ) : (
          rights &&
          rights.Is_Delete && (
            <div
              onClick={() => {
                IconAction("Delete");
              }}
            >
              <MdDelete //className="icon_styling delete_icon_style"
                className={"icon_styling"}
              />
              <p //className="IconName"
                className={"IconName"}
              >
                DELETE
              </p>
            </div>
          )
        )}

        <div onClick={() => IconAction("Refresh")}>
          <div ref={Refresh_icon_ref} style={{ borderRadius: "50%" }}>
            <RiRefreshLine size={20} className="icon_styling delete_icon_style FiRefreshCcw" />
          </div>
          <p className="IconName"> REFRESH</p>
        </div>
        {rights && rights.Is_Print === true && (
          <div
            div
            onClick={() => {
              // console.log("print");
              IconAction("Print");
            }}
          >
            <AiFillPrinter className="icon_styling delete_icon_style" />
            <p className="IconName">PRINT</p>
          </div>
        )}
        {rights && rights.Is_Close && (
          <div
            onClick={() => {
              if (RowSelect) {
                closeFun();
              } else {
                P_Select_row();
              }
            }}
          >
            <div ref={Refresh_Count_ref} style={{ borderRadius: "50%" }}>
              <IoClose size={20} className="icon_styling delete_icon_style FiRefreshCcw" />
            </div>
            <p className="IconName"> CLOSE</p>
          </div>
        )}

        {rights && rights.Is_Lock && (
          <div
            onClick={() => {
              // if (checkMinimumRowSelection()) {
              IconAction("Lock");
              // }
            }}
          >
            <AiFillLock className="icon_styling delete_icon_style" />
            <p className="IconName">LOCK</p>
          </div>
        )}

        {rights && rights.Is_Unlock && (
          <div
            onClick={() => {
              // if (checkMinimumRowSelection()) {
              IconAction("Unlock");
              // }
            }}
          >
            <AiFillUnlock className="icon_styling delete_icon_style" />
            <p className="IconName">UNLOCK</p>
          </div>
        )}

        {rights && rights.Is_Count && (
          <div
            onClick={() => {
              IconAction("Count");
              func();
            }}
          >
            <div ref={Refresh_Count_ref} style={{ borderRadius: "50%" }}>
              <IoRefreshCircle size={20} className="icon_styling delete_icon_style FiRefreshCcw" />
            </div>
            <p className="IconName"> COUNT</p>
          </div>
        )}

        {rights && rights.Process && (
          <div onClick={() => IconAction("process")}>
            {/* <FcProcess className="icon_styling processIcon" /> */}
            <Image name={"processIcon"} img={process_icon} />
            <p className="IconName">PROCESS</p>
          </div>
        )}
        {rights && rights.Send_Notification && (
          <div onClick={() => setNotification(true)}>
            {/* <FcProcess className="icon_styling processIcon" /> */}
            {/* <Button name="modalbutton" text={"SEND NOTIFICATION"} /> */}
            <IoIosNotifications size={20} className="icon_styling" />
            <p className="IconName">NOTIFICATION</p>
          </div>
        )}
        {rights && MoreIcons}
        {/* If the type is "Add," "Edit," "View," or "Delete," the function will return the corresponding component based on the location pathname. */}
        {type === "Print" && toggle && (
          <InvoiceFormat
            show={toggle}
            title={title}
            TableKey={TableKey}
            TypeOfPortal={type}
            ParentPortalCloseFunction={ParentPortalCloseFunction}
          />
        )}

        {Notification && (
          <BulkNotifications
            Modal_Key={"EMT_Accounts_Notification"}
            ParentPortalCloseFunction={() => {
              setNotification(false);
            }}
            show={Notification}
          />
        )}
      </div>
    </div>
  );
}

export default memo(IconsDiv);
